import React from 'react';
import { Link } from 'react-router-dom';

const ConditionalLink = ({
    children,
    to,
    target,
    onLinkClick,
}: {
    children: React.ReactNode;
    to?: string;
    target?: React.HTMLAttributeAnchorTarget;
    onLinkClick?: React.MouseEventHandler<HTMLElement>;
}) => {
    if (!to) {
        return <>{children}</>;
    }

    return (
        <Link to={to} target={target} onClick={onLinkClick} draggable={false}>
            {children}
        </Link>
    );
};

export default ConditionalLink;
